import React from 'react';
import { InfoOutline } from '@yme/assets/icons';
import { Col, Row } from '@yme/atoms/grid';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { AccessoryDisclaimerStyled, HeroSectionContentStyled } from '../styled';
import { HeroInfo } from './HeroInfo';
import { HeroSectionButtonsPanel } from './HeroSectionButtonsPanel';
export function HeroSectionMainContent({ labels, isRightToLeft, isMobileView, configuratorVersion, productPhotoDisclaimers, configuratorLeadFormPagePath, hasForOwnersComponent, currentColorTheme, scrollToId, }) {
    const productPhotoDisclaimerExpanded = productPhotoDisclaimers.length > 0 && !isMobileView;
    return (React.createElement(HeroSectionContentStyled, null,
        React.createElement(HeroInfo, null),
        !isMobileView && (React.createElement(HeroSectionButtonsPanel, { isRightToLeft: isRightToLeft, hasForOwnersComponent: hasForOwnersComponent, labels: labels, currentColorTheme: currentColorTheme, configuratorVersion: configuratorVersion, configuratorLeadFormPagePath: configuratorLeadFormPagePath, scrollToId: scrollToId })),
        productPhotoDisclaimerExpanded && (React.createElement(Row, null,
            React.createElement(Col, null, productPhotoDisclaimers.map((productPhotoDisclaimer) => (React.createElement(AccessoryDisclaimerStyled, { key: productPhotoDisclaimer },
                React.createElement(SVGIcon, { type: InfoOutline, size: ICON_SIZE.xs }),
                productPhotoDisclaimer))))))));
}
